import { render, staticRenderFns } from "./ClaimButtons.vue?vue&type=template&id=9a7fb962&scoped=true"
import script from "./ClaimButtons.vue?vue&type=script&lang=js"
export * from "./ClaimButtons.vue?vue&type=script&lang=js"
import style0 from "./ClaimButtons.vue?vue&type=style&index=0&id=9a7fb962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7fb962",
  null
  
)

export default component.exports